import { render } from "./chartF.vue?vue&type=template&id=ef8254b0"
import script from "./chartF.vue?vue&type=script&lang=ts"
export * from "./chartF.vue?vue&type=script&lang=ts"
script.render = render

export default script